import { GridColDef, GridColumnVisibilityModel } from "@mui/x-data-grid-pro";

// A column with hideable: false is not a preference. Saved settings cannot show a filter-only
// column or hide an action column.
export function lockColumnVisibility(
  columns: readonly Pick<GridColDef, "field" | "hide" | "hideable">[],
  initialModel: GridColumnVisibilityModel | undefined,
  persistedModel: GridColumnVisibilityModel,
): GridColumnVisibilityModel {
  const locked: GridColumnVisibilityModel = {};
  columns.forEach((column) => {
    if (column.hideable !== false) return;
    const hidden = column.hide === true || initialModel?.[column.field] === false;
    locked[column.field] = !hidden;
  });
  return { ...initialModel, ...persistedModel, ...locked };
}
